module.exports = __webpack_public_path__ + "static/metodo-42df679f625c19eb0f127df664a21a2d.png";